import React, { useCallback, useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import classnames from 'classnames';
import { useMutation, useQuery } from '@apollo/client';
import { unwrap } from 'api/schema/utils';
import GET_ORDER_MODELS from 'api/queries/GET_ORDER_MODELS';
import TickIcon from 'images/icons/icn-tick.svg';
import CircleQuestion from 'images/icons/circle-question-solid.svg';
import './ProductionVolume.scss';
import '../OrdersListCommon.scss';
import Scrollable from 'common/Scrollable';
import { useTranslation } from 'react-i18next';
import REMOVE_ORDER_MODEL from 'api/mutations/REMOVE_ORDER_MODEL';
import { OrderSpecificationContext } from 'views/OrdersList/OrderSpecificationProvider';
import OrderModelButton from 'views/OrdersList/OrderModelButton';
import TextPlaceholder from '../../../components/common/TextPlaceholder/TextPlaceholder';
import ModelVolume from './ModelVolume';
const ProductionVolume = ({ order }) => {
    var _a;
    const { data: modelsData } = useQuery(GET_ORDER_MODELS, {
        variables: { id: order.id },
    });
    const { t } = useTranslation('orders');
    const models = unwrap((_a = modelsData === null || modelsData === void 0 ? void 0 : modelsData.node) === null || _a === void 0 ? void 0 : _a.models) || [];
    const history = useHistory();
    const [selectedModel, setSelectedModel] = useState();
    const selectModel = useCallback((model) => () => {
        setSelectedModel(model);
    }, [setSelectedModel]);
    const goToSpecificationSummary = useCallback((modelSpecificationId) => {
        history.push(`/specifications/details/${modelSpecificationId}/summary`);
    }, [history]);
    const getPath = (orderModelNode) => {
        var _a, _b, _c, _d;
        return ((_c = (_b = (_a = orderModelNode === null || orderModelNode === void 0 ? void 0 : orderModelNode.modelSpecificationNode) === null || _a === void 0 ? void 0 : _a.folder) === null || _b === void 0 ? void 0 : _b.path) === null || _c === void 0 ? void 0 : _c.map((path) => `${path.name} / `).join('')) + ((_d = orderModelNode === null || orderModelNode === void 0 ? void 0 : orderModelNode.modelSpecificationNode) === null || _d === void 0 ? void 0 : _d.itemCode);
    };
    const { folder, refetchFolderContentsData } = useContext(OrderSpecificationContext);
    const [removeOrderModel] = useMutation(REMOVE_ORDER_MODEL);
    const handleRemoveOrderModel = useCallback((modelSpecificationId) => {
        var _a;
        const orderModelId = (_a = unwrap(order === null || order === void 0 ? void 0 : order.models).find((e) => e.modelSpecificationNode.id === modelSpecificationId)) === null || _a === void 0 ? void 0 : _a.id;
        removeOrderModel({
            variables: {
                orderModelId,
            },
        }).then(() => {
            setSelectedModel(undefined);
            refetchFolderContentsData(folder.id);
        });
    }, [folder, order === null || order === void 0 ? void 0 : order.models, refetchFolderContentsData, removeOrderModel]);
    return (React.createElement("div", { className: "ProductionVolume" },
        React.createElement(Scrollable, { className: "LeftSideBar" }, models === null || models === void 0 ? void 0 : models.map((model) => (React.createElement(React.Fragment, { key: model.modelSpecificationNode.id },
            React.createElement("div", { "aria-hidden": "true", className: classnames({
                    'Card': true,
                    'nav-item': true,
                    'nav-item--highlighted': (model === null || model === void 0 ? void 0 : model.id) === (selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.id),
                }), onClick: selectModel(model), onKeyDown: selectModel(model) },
                React.createElement("div", { className: "flex items-center" },
                    React.createElement("div", { className: "icon-24 mr-4" }, model.modelReady ? React.createElement(TickIcon, null) : React.createElement(CircleQuestion, null)),
                    React.createElement("div", { className: "nav-item-value" }, getPath(model))),
                React.createElement(OrderModelButton, { goToSpecificationSummary: goToSpecificationSummary, handleRemoveOrderModel: handleRemoveOrderModel, specId: model.modelSpecificationNode.id })))))),
        React.createElement(Scrollable, { className: "volume" }, selectedModel ? (React.createElement(ModelVolume, { order: order, orderModel: selectedModel })) : (React.createElement(TextPlaceholder, { message: t('volumen_list_placeholder') })))));
};
export default ProductionVolume;
